import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { useWorkspaceContext } from 'hooks/common';
import type { SinglePluginConnectionsResponse } from 'types/PluginConnections';

type mutationVariables = { pluginConnectionID: string | undefined };

export function usePluginConnectionTest() {
  const queryClient = useQueryClient();
  const { currentWorkspaceID } = useWorkspaceContext();

  const pluginConnectionTest = (connectionConfigure: mutationVariables) => {
    const { pluginConnectionID } = connectionConfigure;

    if (!pluginConnectionID) {
      Promise.reject('pluginConnection ID can not be null');
    }

    const body = {
      data: {
        id: pluginConnectionID,
        type: SPARK_RESOURCE_TYPES.PLUGIN_CONNECTIONS,
        attributes: {
          workspaceID: currentWorkspaceID,
        },
      },
    };

    return fetchWrapper<SinglePluginConnectionsResponse>({
      url: SPARK_RESOURCE_TYPES.PLUGIN_CONNECTIONS_TEST,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('PluginConnectionTest', pluginConnectionTest, {
    onSuccess: (data) => {
      queryClient.invalidateQueries('pluginConnection');
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to test Plugin Connection: ${error.message}`);
      }
    },
  });
}
